import { Actions } from './actions';
import {
  VERIFY_PHONE_REQUEST,
  VERIFY_PHONE_SUCCESS,
  VERIFY_PHONE_ERROR,
  CLEAR_STATE_VERIFYING,
  SET_ISSUCCESS_VERIFYING,
  SET_IS_WRONG_CODE,
  SET_ISSUCCESS,
} from './constants';

const initialState = {
  loading: false,
  errorMsg: null as string | null,

  number: '',
  isSuccess: false as boolean,
  isError: false as boolean,
  isLoadingFields: '' as string,
  code: null as string | null,
  isStatusTrue: true as boolean,
};

export type VerifyPhoneState = typeof initialState;

export const verifyPhoneReducer = (state: VerifyPhoneState = initialState, action: Actions) => {
  switch (action.type) {
    case VERIFY_PHONE_REQUEST: {
      return {
        ...state,
        loading: true,
        errorMsg: null,
        number: action.payload,
        isLoadingFields: action.field,
        code: action.code,
        isSuccess: false,
        isError: false,
      };
    }
    case VERIFY_PHONE_SUCCESS: {
      return {
        ...state,
        loading: false,
        errorMsg: null,
        isStatusTrue: true,
      };
    }
    case SET_ISSUCCESS: {
      return {
        ...state,
        isStatusTrue: action.payload,
      };
    }
    case VERIFY_PHONE_ERROR: {
      return {
        ...state,
        code: null,
        errorMsg: action.payload,
        loading: false,
        isSuccess: false,
        isStatusTrue: false,
      };
    }
    case SET_ISSUCCESS_VERIFYING: {
      return {
        ...state,
        errorMsg: null,
        loading: false,
        isSuccess: true,
        isError: false,
      };
    }
    case SET_IS_WRONG_CODE: {
      return {
        ...state,
        isError: true,
      };
    }
    case CLEAR_STATE_VERIFYING: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
